

// src/services/googleLoginService.js
import axiosInstance from "../config";
import { jwtDecode } from "jwt-decode";

/**
 * Send Google token to backend
 * @param {string} credential - Google JWT token
 */
export const googleLoginService = async (credential) => {
  try {
    if (!credential) {
      // Token not provided, skip decoding / sending
      return {
        success: false,
        message: "No token provided",
        status: 400,
      };
    }

    // Decode token for frontend use (optional)
    const user = jwtDecode(credential);

    

    // Send token to backend signup/login endpoint
    const response = await axiosInstance.post(
      "/g/google_login", // replace with your backend path
      { gtoken: credential },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credential}`, // optional
        },
      }
    );

    return {
      success: true,
      user,                 // decoded Google info
      data: response.data,  // backend response
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Google login failed",
      status: error.response?.status || 500,
      errors: error.response?.data?.errors || null,
    };
  }
};
